import { createReducer } from "@reduxjs/toolkit";
import {
  deleteDeviceSuccess,
  getDeviceListSuccess,
  LoadingData,
  loadingList,
  saveDeviceListSuccess,
} from "./deviceManagementActions";

export interface IDeviceManagementState {
  deviceList: Array<any>;
  dataCount: number;
  isLoading: boolean;
}

const initialState: IDeviceManagementState = {
  deviceList: [],
  dataCount: 0,
  isLoading: false,
};

export const deviceManagementReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getDeviceListSuccess, (state, action) => {
      state = {
        ...state,
        deviceList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(saveDeviceListSuccess, (state, action) => {
      state = {
        ...state,
        deviceList: action.payload,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })

    .addCase(deleteDeviceSuccess, (state, action) => {
      const filteredList = state.deviceList.filter(
        (item) => !action.payload.includes(item.id)
      );
      return {
        ...state,
        deviceList: filteredList,
      };
    });
});


